import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FormControl, FormGroup } from 'react-bootstrap'

import { mapToSelectArray } from 'Shared/helpers'
import { GlgPopupForm, GlgFormInput, GlgSelect } from 'SharedComponents'
import { getCategoriesOptions, getSeasonsOptions } from '../../../../selectors'

const DetailsEventOrLeague = ({
  currentSeasonId,
  categoriesOptions,
  seasonsOptions,
  details,
  setDetails,
}) => {

  useEffect(() => {
    const updates = {}

    if (!details.category && categoriesOptions.length > 0) {
      updates.category = categoriesOptions[0].value
      updates.categoryName = categoriesOptions[0].label
    }

    if (!details.season && currentSeasonId) {
      const defaultSeason = seasonsOptions.find(season => season.value === String(currentSeasonId))
      if (defaultSeason) {
        updates.season = defaultSeason.value
        updates.seasonName = defaultSeason.label
      }
    }

    if (Object.keys(updates).length > 0) {
      setDetails({ ...details, ...updates })
    }
  }, [])

  const onNameChange = (e) => {
    setDetails({ ...details, name: e.target.value })
  }

  const handleCategoryChange = (e) => {
    const selectedCategory = categoriesOptions.filter(category => category.value === String(e))
    setDetails({ ...details, categoryName: selectedCategory[0].label, category: selectedCategory[0].value })
  }

  const handleSeasonChange = (e) => {
    const selectedSeason = seasonsOptions.filter(season => season.value === String(e))
    setDetails({ ...details, seasonName: selectedSeason[0].label, season: selectedSeason[0].value })
  }

  return (
    <span className='popup_form_content'>
      <h2>{ !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.sim_golf.details_header') }</h2>
      <p className='content_information'>{ !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.sim_golf.details_subtitle', { type: details.product || 'event or league' } ) }</p>
      <GlgPopupForm>
        <GlgFormInput
          label={ !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.sim_golf.name_label') }
        >
          <FormGroup>
            <FormControl
              name='league[name]'
              type='text'
              value={ details.name }
              onChange={ onNameChange }
              autoFocus={ true }
              placeholder={ !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.sim_golf.name_input_placeholder') }
            />
          </FormGroup>
        </GlgFormInput>
        <GlgFormInput
          label={ !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.sim_golf.category_label') }
        >
          <GlgSelect
            className='container_select'
            name='category'
            items={ categoriesOptions }
            onChange={ handleCategoryChange }
            value={ details.category }
          />
        </GlgFormInput>
        <GlgFormInput
          label={ !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.sim_golf.season_label') }
        >
          <GlgSelect
            className='container_select'
            name='season'
            items={ seasonsOptions }
            onChange={ handleSeasonChange }
            value={ details.season || currentSeasonId }
          />
        </GlgFormInput>
      </GlgPopupForm>
    </span>
  )
}

DetailsEventOrLeague.propTypes = {
  currentSeasonId: PropTypes.string,
  categoriesOptions: PropTypes.array.isRequired,
  seasonsOptions: PropTypes.array.isRequired,
  details: PropTypes.object.isRequired,
  setDetails: PropTypes.func.isRequired,
}

const mapStateToProps = state => {
  const categoriesOptions = getCategoriesOptions(state, { useManagedCustomer: true })
  const categoriesSelectOptions = mapToSelectArray(categoriesOptions)
  const seasonsOptions = getSeasonsOptions(state, { useManagedCustomer: true })
  const currentSeason = seasonsOptions.find(season => season.isCurrent)
  const currentSeasonId = _.get(currentSeason, 'id')
  const seasonsSelectOptions = mapToSelectArray(seasonsOptions)

  return {
    categoriesOptions: categoriesSelectOptions,
    seasonsOptions: seasonsSelectOptions,
    currentSeasonId,
    customerId: state.misc.managedCustomerId,
  }
}

export default connect(mapStateToProps)(DetailsEventOrLeague)
